import { Trans } from '@lingui/macro'
import { Typography } from '@mui/material'
import type { EnhancedDomain } from 'sunlife-domain'

import {
  AttributeCardSelector,
  LocalizableMessage,
  MaterialSwatchSelector,
} from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

export const DesignProperties = (props: { entity: EnhancedDomain.$WithDesign }) => {
  const { entity } = props
  return (
    <PropertyContainer.Group spacing="large">
      <PropertyContainer.Item
        title={
          <Typography>
            <Trans>Collection</Trans>
          </Typography>
        }
        action={
          <Typography variant="body2">
            <LocalizableMessage>{entity.$selectedCollection.name}</LocalizableMessage>
          </Typography>
        }
      >
        <AttributeCardSelector entityId={entity.id} instanceName="collection" />
      </PropertyContainer.Item>
      {entity.$selectedCollection.type === 'colors' && (
        <PropertyContainer.Item
          title={
            <Typography>
              <Trans>Color</Trans>
            </Typography>
          }
          action={
            <Typography variant="body2">
              <LocalizableMessage>{entity.$selectedDesign.name}</LocalizableMessage>
            </Typography>
          }
        >
          <MaterialSwatchSelector entityId={entity.id} instanceName="color" />
        </PropertyContainer.Item>
      )}
      {entity.$selectedCollection.type === 'textures' && (
        <PropertyContainer.Item
          title={
            <Typography>
              <Trans>Design</Trans>
            </Typography>
          }
          action={
            <Typography variant="body2">
              <LocalizableMessage>{entity.$selectedDesign.name}</LocalizableMessage>
            </Typography>
          }
        >
          <AttributeCardSelector entityId={entity.id} instanceName="texture" />
        </PropertyContainer.Item>
      )}
    </PropertyContainer.Group>
  )
}
